jQuery(document).ready(function ($) {
    const items = [];

    $('.js-property-item').each(function () {
        items.push(new Swiper(`.js-property-item[data-property-id="${$(this).attr('data-property-id')}"]`, {
            loop: true,

            slidesPerView: 1,

            autoplay: true,
            delay: 3000,

            //grabCursor: true,

            navigation: {
                prevEl: '.property-item__prev',
                nextEl: '.property-item__next'
            },

            pagination: {
                el: '.property-item__pagination',
                bulletClass: 'property-item__bullet',
                bulletActiveClass: 'active'
            },

            slideClass: 'property-item__image'
        }));
    });
});